/**
 * @template T
 * @param {import("@seabrookstudios/pitch2table-core").AdvancedFilter<T>} advancedFilter
 * @returns {function(T[], string[]): T[]}
 */
export const makeAdvancedFilter = (advancedFilter) => {
  /**
   * @param {T[]} records
   * @param {string[]} selections
   * @returns {T[]}
   */
  const applyFilter = (records, selections) => {
    const { filter } = advancedFilter;
    return records.filter((record) => filter(selections, record));
  };

  return applyFilter;
};

/**
 * Applies multiple advanced filters as an AND (intersection) across the list.
 * @template T
 * @param {T[]} items
 * @param {import("@seabrookstudios/pitch2table-core").AdvancedFilter<T>[]} advancedFilters
 * @param {Record<string, string[]>} selectionsByLabel
 * @returns {T[]}
 */
export const applyAdvancedFilters = (items, advancedFilters, selectionsByLabel) => {
  return advancedFilters.reduce((currentItems, advancedFilter) => {
    const selections = selectionsByLabel[advancedFilter.label] ?? [];
    return makeAdvancedFilter(advancedFilter)(currentItems, selections);
  }, items);
};
